<script lang="ts">
	import BurgerButton from './BurgerButton.svelte';
	import { classnames } from './utils';

	let openMenu: boolean = $state(false);

	let wrapEl: HTMLElement | null = $state(null);
	let verticalMenuEl: HTMLElement | null = $state(null);

	$effect(() => {
		((window as any).document.querySelector('body') as HTMLElement).append(wrapEl);
		((window as any).document.querySelector('body') as HTMLElement).append(verticalMenuEl);

		wrapEl?.addEventListener('click', () => {
			openMenu = false;
		});
	});

	function autoCloseMenu() {
		openMenu = false;
	}
	$effect(() => {
		(window as any).addEventListener('resize', autoCloseMenu);

		return () => {
			(window as any).removeEventListener('resize', autoCloseMenu);
		};
	});

	let menuHTML: string = $state('');

	$effect(() => {
		openMenu;
		console.log('openMenu', openMenu);

		menuHTML = (window as any).document.querySelector('#landing-menu')?.innerHTML ?? '';

		if (wrapEl) {
			wrapEl.style.display = openMenu ? '' : 'none';

			((window as any).document.querySelector('body') as HTMLElement).style.overflow = openMenu
				? 'hidden'
				: '';
		}
	});
</script>

<BurgerButton class="d-lg-none" bind:open={openMenu}></BurgerButton>

<div class="modal_wrap" bind:this={wrapEl}></div>

<div
	class={classnames('vertical-menu', { 'vertical-menu__open': openMenu })}
	bind:this={verticalMenuEl}
>
	<ul>{@html menuHTML}</ul>
</div>

<style lang="sass">
.modal_wrap
	position: fixed
	top: 0
	bottom: 0
	left: 0
	right: 0
	background: rgba(0,0,0, 0.2)


:global(.vertical-menu)
	position: fixed
	top: 0
	left: 0
	height: 100%
	background-color: #f8f8f8
	padding: 9rem  1rem 1rem
	transition: translate 0.3s
	translate: (-100%)
	font-size: 1.2em
	:global( ul )
		padding-left: 0

	:global( li )
		list-style: none
		color: #0d6efd

:global(.vertical-menu__open)
	translate: (0%)
</style>
